import { distanceInWordsStrict } from 'date-fns'

export default function (value, options = {}) {
  let distance = value ? distanceInWordsStrict(new Date(), value, options) : ''

  // @TODO: Ugly hack, because date-fns has no Hungarian translation yet (although it's in a PR)
  distance = distance
    .replace(/days?/, 'nap')
    .replace(/hours?/, 'óra')
    .replace(/minutes?/, 'perc')
    .replace(/seconds?/, 'másodperc')

  return distance
}



// WEBPACK FOOTER //
// ./src/filters/distance-in-words.js